var _defs, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNa = function SvgNa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "na_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h90v60H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003580",
    d: "M0 60V0h90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M90 0v60H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#na_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 20,
    d: "M0 60 90 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d21034",
    strokeWidth: 15,
    d: "M0 60 90 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffce00",
    transform: "translate(18 16.341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-10 1.55 4.2L5-8.66l-.76 4.42L8.66-5 5.8-1.55 10 0 5.8 1.55 8.66 5l-4.42-.76L5 8.66 1.55 5.8 0 10l-1.55-4.2L-5 8.66l.76-4.42-4.42.76 2.86-3.45L-10 0l4.2-1.55L-8.66-5l4.42.76L-5-8.66l3.45 2.86z"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.5,
    stroke: "#003580"
  }))));
};
export default SvgNa;